import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatValue, getCardApiValue } from '../helpers';
import { checkKpiType } from '@flexo/general';

const InformationCardContentSiteTypeLabelValue = ({ description, cardValue, id, overviewKpiApiData }) => {
  const { t } = useTranslation();
  const metadata = useSelector((state: any) => state.metadata);

  const selectedEntity = metadata?.selectedEntity;
  if (typeof description === 'string') {
    return (
      <div>
        <span className="paragraph">
          {t(
            metadata?.[
              selectedEntity?.siteType?.[0]?.siteType || 'default'
            ]?.description
          )}
        </span>
        <span className="paragraph">
          <span className="heading5">{cardValue?.value || '-.- '} </span>
        </span>
      </div>
    );
  } else if (Array.isArray(description)) {
    return (
      <div>
        {description.map((el, i, array) => (
          <div key={`${id}-label-value-label-value-array-siteType-${i}`}>
            <span className={`color-hive-greyscale-600`}>
              <span className="font-flexo-semibold heading5">{t(el.key)} </span>
              {el.value}
            </span>
            {i < array.length - 1 && <br />}
          </div>
        ))}
      </div>
    );
  } else if (description && typeof description === 'object' && Object.keys(description).length > 0) {
    const type = selectedEntity?.siteType?.[0]?.siteType || selectedEntity?.type || 'default';
    return (
      <div>
        {description[type]?.map((el, i, array) => (
          <div key={`${id}-label-value-label-value-array-siteType-object-${i}`}>
            <span className={`color-hive-greyscale-600`}>
              <span className="font-flexo-semibold heading5">{t(el.key)} </span>
              { formatValue(getCardApiValue(el?.value, overviewKpiApiData)?.value || '-.- ', 'site', checkKpiType) +
                      (getCardApiValue(el?.value, overviewKpiApiData)?.unit ||
                        getCardApiValue(el?.value, overviewKpiApiData)?.unit_type ||
                        '')}
            </span>
            {i < array.length - 1 && <br />}
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export default InformationCardContentSiteTypeLabelValue; 